import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { NotificationPreferencesDto } from '../../api/notificationTypes';

type NotificationsState = {
  /** Null until the first load. */
  preferences: NotificationPreferencesDto | null;
  status: 'idle' | 'loading' | 'error';
  /** Keys of requests in flight: 'all', 'category:<id>' or 'type:<id>'. */
  pending: string[];
};

const initialState: NotificationsState = {
  preferences: null,
  status: 'idle',
  pending: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setPreferences(state, action: PayloadAction<NotificationPreferencesDto>) {
      state.preferences = action.payload;
    },
    setStatus(state, action: PayloadAction<NotificationsState['status']>) {
      state.status = action.payload;
    },
    addPending(state, action: PayloadAction<string>) {
      state.pending.push(action.payload);
    },
    removePending(state, action: PayloadAction<string>) {
      const index = state.pending.indexOf(action.payload);
      if (index !== -1) state.pending.splice(index, 1);
    },
    resetNotifications() {
      return initialState;
    },
  },
});

export const notificationsReducer = notificationsSlice.reducer;
export const notificationsActions = notificationsSlice.actions;
